import React from 'react'
import "./Home.css"

import Product from './Product'


function Home() {
  return (
    <div className='home'>
        <div className='home-container'>
            <img src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220.jpg" className='banner'/>


        <div className='home-row'>
                <Product id={1} title="KitchenAid KITCH K45SSOB Mixer 4.5, 250watts, Onyx Red" image="https://i.ibb.co/4FdxDJ1/mixer.jpg" price={119.99} rating={4}/>
                <Product id={2} title="ASUS ROG Strix Go 2.4 Wireless Gaming Headset with USB-C 2.4 GHz Adapter | Ai Powered Noise-Cancelling Microphone | Over-Ear Headphones for PC, Mac, Nintendo Switch, and PS5/4" image="https://i.ibb.co/VNX21JZ/Headphones.jpg" price={99.99} rating={3}/>
          </div>
        <div className='home-row'>
                <Product id={3} title="OTTERBOX COMMUTER SERIES Case for iPhone 13 Pro Max & iPhone 12 Pro Max - ROCK SKIP WAY" image="https://m.media-amazon.com/images/I/61kQg2ARtNL._AC_SX522_.jpg" price={29.99} rating={5}/>
              <Product id={4} title="Apple iPad Pro 12.9inces 2020 128GB WiFi Space Gray" image="https://i.ebayimg.com/images/g/K1sAAOSw2ylidXAo/s-l500.jpg" price={1299.99} rating={5}/>
              <Product id={5} title="Dell XPS Business Laptop, 15.6 Inch FHD+, Intel Core i7-10750H Processor, 32GB RAM, 1TB PCIe SSD, GeForce GTX 1650 Ti 4GB GDDR6, Fingerpring Reader, Backlit Keyboard, Windows 11 Home (Latest Model)" image="https://m.media-amazon.com/images/I/61dsIaHmvgL._AC_SX522_.jpg" price={1730.99} rating={4}/>
          </div>
        <div className='home-row'>

        <Product id={5} title="V76 by Vaughn Energizing Shampoo Daily Revitalizing Formula for Men" image="https://m.media-amazon.com/images/I/41GJWutKSYL._SX522_.jpg" price={11.99} rating={2}/>

          </div>
      </div>
    </div>

  )
}

export default Home